module.exports = __webpack_public_path__ + "static/media/x-4.4ae38293.svg";